import React, {useEffect, useState} from 'react';
import OrderHeadSectionComponent from "../../components/headSection/components/OrderHeadSectionComponent";
import ProfilePath from "../profileSection/components/ProfilePath";
import {Button} from "@mui/material";
import ContactSectionComponent from "../../pages/main/sections/contactSection/ContactSectionComponent";
import "./contactUsSection.scss";
import { useTranslation } from "react-i18next";

const ContactUsComponent = () => {
    const { t } = useTranslation();
    
    const [name, setName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [textMessage, setTextMessage] = useState<string>('');

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const existUser = JSON.parse(sessionStorage.getItem('user') as any);
        if (existUser) {
            setName(existUser.name);
            setEmail(existUser.email);
        }
    }, []);

    const handleButtonFormSendHelpMessage = async () => {
        try {
            if (name && email && textMessage) {
                alert("Send message successfully");
                setTextMessage('');
                /*const response = await fetch('http://localhost:5000/api/auth/help', {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({
                        name,
                        email,
                        textMessage
                    })
                });
                const content = await response.json();
                console.log("update content: ", content);*/
                /*if (content) {
                    alert("successfully send");
                }*/
            } else {
                alert("Please fill in all fields");
            }
        } catch (e) {
            console.log("error e: ", e);
        }
    }

    return (
        <div className="contactUsComponent__container">
            <div className="mainSectionComponent__container-content-overlay"></div>
            <OrderHeadSectionComponent />
            <ProfilePath
                path={['Contact Us']}
                component="Contact Us"
            />
            <div className="contactUsComponent__container-content">
                <form className="profileSectionDataForm__container_content_form">
                    <div className="profileSectionDataForm__container_content_form_input_wrap name">
                        <label htmlFor="name">{t('contactUs.name')}</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            required
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>

                    <div className="profileSectionDataForm__container_content_form_input_wrap email">
                        <label htmlFor="email">{t('contactUs.email')}</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className="profileSectionDataForm__container_content_form_input_wrap message">
                        <label htmlFor="message">{t('contactUs.howCanWeHelpYou')}</label>
                        <textarea
                            id="message"
                            name="message"
                            required
                            value={textMessage}
                            onChange={(e) => setTextMessage(e.target.value)}
                        />
                    </div>

                </form>

                <div className="profileSectionDataForm__container-button-btn_wrap">
                    <Button
                        className="profileSectionDataForm__container-button-btn save"
                        variant="contained"
                        onClick={handleButtonFormSendHelpMessage}
                        disabled={!(name && email && textMessage)}
                    >
                            <span>{t('buttons.submit')}</span>
                    </Button>
                </div>

            </div>
            <ContactSectionComponent />
        </div>
    );
};

export default ContactUsComponent;